export var TypeActionAppsflyer;
(function (TypeActionAppsflyer) {
    TypeActionAppsflyer["LevelUp"] = "Appsflyer > Level Up";
    TypeActionAppsflyer["Purchase"] = "Appsflyer > Purchase";
    TypeActionAppsflyer["Update"] = "Appsflyer > Update";
})(TypeActionAppsflyer || (TypeActionAppsflyer = {}));
export var actionAppsflyerLevelUp = function (playerLevel) { return ({
    playerLevel: playerLevel,
    type: TypeActionAppsflyer.LevelUp,
}); };
export var actionAppsflyerPurchase = function (currency, price, packageId, isFirstPurchase) { return ({
    currency: currency,
    isFirstPurchase: isFirstPurchase,
    packageId: packageId,
    price: price,
    type: TypeActionAppsflyer.Purchase,
}); };
export var actionAppsflyerUpdate = function (eventName, eventValue) { return ({
    eventName: eventName,
    eventValue: eventValue,
    type: TypeActionAppsflyer.Update,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/appsflyer/actionAppsflyer.ts
// module id = 212
// module chunks = 3